module.exports = __webpack_public_path__ + "img/logo_stable_trnspr.05cc5e02.png";